<mat-form-field>
  <mat-label>{{label | translate}}</mat-label>
  <input matInput #input [style.color]="color" [disabled]="mode!=Mode.edition" [maxLength]="length" [required]="required"
    [type]="type" [value]="value" (input)="valueChange.emit(input.value)">
  <mat-hint *ngIf="hint" class="hint">{{hint | translate}}</mat-hint>
  <mat-error *ngIf="required">{{'Mandatory field' | translate}}</mat-error>
</mat-form-field>
